import { Link, useLocation } from "react-router-dom";
import { CheckCircle2 } from "lucide-react";
import PageShell from "@/components/PageShell";

export default function ApplySuccess() {
    const { state } = useLocation();
    return (
        <PageShell>
            <section className="max-w-3xl mx-auto px-6 py-24 text-center" data-testid="apply-success-page">
                <div className="inline-flex items-center justify-center w-20 h-20 rounded-full bg-brand-orange/10 mb-6">
                    <CheckCircle2 className="h-12 w-12 text-brand-orange" />
                </div>
                <h1 className="font-heading text-4xl md:text-5xl font-black uppercase text-brand-navy">Thank you</h1>
                <p className="mt-6 text-slate-700 text-lg leading-relaxed">
                    Thank you for applying with Tower Staffing. We will be in contact promptly <em>if</em> our teams feel there is, or will be, a fitting position available soon.
                </p>
                {state?.id && (
                    <p className="mt-6 text-sm text-slate-500">Reference: <span className="font-mono font-bold">{state.id}</span></p>
                )}
                <div className="mt-10 flex flex-wrap gap-3 justify-center">
                    <Link to="/" className="border-2 border-slate-200 hover:border-brand-orange text-brand-navy px-6 py-3 rounded-sm font-heading uppercase tracking-wider font-bold text-sm">Back to home</Link>
                    <Link to="/jobs" className="bg-brand-orange hover:bg-brand-navy text-white px-6 py-3 rounded-sm font-heading uppercase tracking-wider font-bold text-sm">Browse jobs</Link>
                </div>
            </section>
        </PageShell>
    );
}
